import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { FileUploadCell } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getAttachmentGroups } from 'ducks/vendorMaintenance'
import { AttachmentContainer, AttachmentDisplayContainer } from './styled'
import { checkAttachmentRequire } from '../../AttributeData'
// import r from 'reactotron-react-js'

const AttachmentForm = (props) => {
  const { valueForm, attachmentGroups, change, isDisplay=false } = props
  const [showAttachment, setShowAttachment] = useState(true)
  const documentTypes = attachmentGroups.data.find(a => a.bpGroup === valueForm.accountGroup) || { attachments: [] }
  const { accountGroup, vendorType } = valueForm
  useEffect(() => {
    if (!attachmentGroups.data.length && !attachmentGroups.loading) {
      props.getAttachmentGroups();
    }
  }, [])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Attachments'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowAttachment(!showAttachment) }>
            {showAttachment ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showAttachment}>
        <CardContent>
          <AttachmentContainer>
            {
              valueForm.purpose === 'block' ? null : documentTypes.attachments.map(d => 
                (d.code === 'VMA03' && accountGroup === 'ZDNT' && vendorType === 'personal') ? 
                null : !editableForm() ? 
                <AttachmentDisplayContainer>
                  <div className='title'>{d.name} {checkAttachmentRequire(d, valueForm)?<span style={{color:'red'}}>*</span>:null}</div>
                  {
                    (valueForm[`attachment${d.code.replace('VMA', '')}`] || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm[`attachment${d.code.replace('VMA', '')}`] || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer> :
                <Field 
                  name={d.code} 
                  label={d.name} 
                  require={checkAttachmentRequire(d, valueForm)} 
                  type={type.file}
                  oldFiles={valueForm[`attachment${d.code.replace('VMA', '')}`] || []}
                  showOldFile
                  removeOldFiles={(index, code) => { 
                    var fieldName = `attachment${code.replace('VMA', '')}`
                    var clone = [...valueForm[fieldName]]
                    clone.splice(index, 1)
                    change(fieldName, [...clone])
                  }}
                  component={FieldInput} />
              )
            }
          </AttachmentContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    attachmentGroups: state.vendorMaintenance.attachmentGroups
  })
}
  

const mapDispatchToProps = {
  getAttachmentGroups
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentForm)